import { render, staticRenderFns } from "./province.vue?vue&type=template&id=788ae71c&scoped=true"
import script from "./province.vue?vue&type=script&lang=js"
export * from "./province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ae71c",
  null
  
)

export default component.exports